import type { JsonSchemaNode } from "@nmblr-platform-flow/schema";

export interface TemplateVariable {
	path: string;
	type: string;
	description?: string;
}

const MAX_DEPTH = 5;

export function flattenSchema(
	prefix: string,
	schema: JsonSchemaNode,
	depth = 0,
): TemplateVariable[] {
	if (depth >= MAX_DEPTH) return [];

	const results: TemplateVariable[] = [];
	const properties = schema.properties;
	if (!properties) return results;

	for (const [key, propSchema] of Object.entries(properties)) {
		const path = `${prefix}.${key}`;
		results.push({ path, type: propSchema.type, description: propSchema.description });

		if (propSchema.type === "object" && propSchema.properties) {
			results.push(...flattenSchema(path, propSchema, depth + 1));
		}

		if (propSchema.type === "array" && propSchema.items) {
			const itemSchema = propSchema.items;
			if (itemSchema.type === "object" && itemSchema.properties) {
				results.push(...flattenSchema(`${path}[]`, itemSchema, depth + 1));
			}
		}
	}

	return results;
}
